export const getProductColor = (pathname) => {
  if (pathname.includes("osenvelt"))
    return "#2B2E8F";
  if (pathname.includes("stoboclo"))
    return "#007178";        
  if (pathname.includes("zymfentra"))
    return "#652E6C";
  return "#000000";
};

export const getBorderColor = (pathname) => {
 if (pathname.includes("osenvelt"))
      return "rselection-wrap role-wrap osenvelt-card";
 if (pathname.includes("stoboclo"))
      return "rselection-wrap role-wrap stoboclo-card";        
 if (pathname.includes("steqeyma"))
      return "rselection-wrap role-wrap steqeyma-card";            
    if (pathname.includes("zymfentra"))
      return "rselection-wrap role-wrap zymfentra-card";
    return "rselection-wrap role-wrap";
  };  


export const getProductButtonColor = (pathname) => {
  if (pathname.includes("osenvelt"))
    return "#2B2E8F";
  if (pathname.includes("stoboclo"))
    return "#007178";        
  if (pathname.includes("steqeyma"))
    return "#006838";
  return "#662d91";
};  

export const getPrimaryButtonClass = (pathname) => {
 if (pathname.includes("osenvelt"))
      return "osenvelt-backbtn";
 if (pathname.includes("stoboclo"))
      return "stoboclo-backbtn";        
    return "backbtn";
  };  

  export const getProductName = (pathname) => {
      if (pathname.includes("steqeyma"))
        return "STEQEYMA";
   if (pathname.includes("osenvelt"))
        return "OSENVELT";
   if (pathname.includes("stoboclo"))
        return "STOBOCLO";        
      if (pathname.includes("zymfentra"))
        return "ZYMFENTRA";
      if (pathname.includes("yuflyma"))
        return "YUFLYMA";
      if (pathname.includes("vegzelma"))
        return "VEGZELMA";    
      return "ADALIMUMAB-AATY";
    };

  export const getMedicationGuideLink = (pathname) => {
      if (pathname.includes("steqeyma"))
        return "https://www.accessdata.fda.gov/drugsatfda_docs/label/2024/761338s000lbl.pdf";
   if (pathname.includes("osenvelt"))
        return "https://www.accessdata.fda.gov/drugsatfda_docs/label/2025/761404s000Orig2lbl.pdf";
   if (pathname.includes("stoboclo"))
        return "#";        
      if (pathname.includes("zymfentra"))
        return "https://www.accessdata.fda.gov/drugsatfda_docs/label/2023/761358s000lbl.pdf";
      if (pathname.includes("yuflyma"))
        return "https://www.accessdata.fda.gov/drugsatfda_docs/label/2023/761219s000lbl.pdf";
      if (pathname.includes("vegzelma"))
        return "https://www.accessdata.fda.gov/drugsatfda_docs/label/2022/761268s000lbl.pdf";    
      return "https://www.accessdata.fda.gov/drugsatfda_docs/label/2023/761219s000lbl.pdf";
    };    